module.exports = __webpack_public_path__ + "static/img/screen-3-en.c32c747.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/how-it-works/screen-3-en.png
// module id = dEaF
// module chunks = 0